// extracted by mini-css-extract-plugin
module.exports = {"footer":"_1Ft33","wrapperCloseBtn":"_1kCxe"};